import type { IFilterTag } from '../types';
import type { IBooleanConfig } from '../configs';

const getBooleanTags = <TFilters>(configs: IBooleanConfig<TFilters>[], filters: TFilters): IFilterTag[] =>
  configs.flatMap(({ key, label }) => {
    const value = filters[key] as boolean | null;
    return value !== null
      ? [{ key: key as string, label: `${ label }: ${ value ? 'Only' : 'Excluded' }`, isExclude: false, removable: true }]
      : [];
  });

export default getBooleanTags;
